/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '@appblocks/codegeneration/Features/LCD';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    const links = project.getNodeLinks(feature, 'lcd_graph_add');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
    lcd_graph_add_point(${project.getNodeParameter(link, 'point')})
    ${doneBlock}`,
        });
    }

    return blocks;
};
